<template>
    <div>
        <Modal v-model="mainTable.sarchCardShow"
            :width="1000"
            :footer-hide="true"
            title="搜素">
            <search-card :form="type==='summary' ? mainTable.searchForm : mainTable.detailSearchForm"
                :table-load-event="getWarehouseEntryTableRecord"
                :table-search="mainTable.tableSearch" />
        </Modal>
        <Modal v-model="show"
            :width="70"
            :footer-hide="true"
            title="入库记录"
            class-name="vertical-center-modal"
            @on-visible-change="onShowChange">
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">内部购销预售入库单列表</span>
                            <RadioGroup v-model="type"
                                @on-change="onTypeChange">
                                <Radio label="summary">汇总</Radio>
                                <Radio label="detail">明细</Radio>
                            </RadioGroup>
                        </div>
                        <div class="right-bar">
                            <Button v-if="$checkAccessArray(['B', 'C'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreateWarehouseEntry">新增</Button>

                            <Button type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>

                            <Button type="info"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-send"
                                @click="onExport()">导出</Button>
                        </div>
                    </div>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="24">
                    <stand-pagination-table :columns="type==='summary'  ? mainTable.columns :mainTable.detailColumns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :extHeight="200"
                        :table-load-event="getWarehouseEntryTableRecord" />
                    </Col>
                </Row>
            </Card>
        </Modal>

        <PreSaleAgentWarehouseEntryEdit ref='preSaleAgentWarehouseEntryEditModal' />
        <WarehouseEntryDetail ref="warehouseEntryDetailModel" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateRender } from '@/libs/tableRowTimeRender';
import PreSaleAgentWarehouseEntryEdit from './preSale-agent-warehouse-entry-edit';
import WarehouseEntryDetail from './preSale-warehouse-entry-detail';
import { getAgentWarehouseEntryList, getAgentWarehouseEntryFullList } from '@/api/modules/warehouse-management/warehouseEntry';
import { DOWNLOAD_SERVER } from '@/api/modules/files';

export default {
    name: 'PreSaleAgentWarehouseEntryList',
    components: {
        SearchCard,
        StandPaginationTable,
        PreSaleAgentWarehouseEntryEdit,
        WarehouseEntryDetail
    },
    data() {
        return {
            show: false,
            type: 'summary',
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '单号', key: 'warehouseEntryRecordBillCode', width: 200, align: 'center' },
                    { title: '批次', key: 'warehouseEntryRecordBatchCode', align: 'center' },
                    { title: '苗场', key: 'seedFarmName', align: 'center' },
                    { title: '项目', key: 'warehouseEntryRecordProject', align: 'center' },
                    { title: '制单人', key: 'userPersonName', align: 'center' },
                    { title: '入库日期', key: 'warehouseEntryRecordCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.warehouseEntryRecordCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            let showElements = [h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                on: {
                                    click: () => {
                                        this.$refs.warehouseEntryDetailModel.showModal(params.row.warehouseEntryRecordUuid);
                                    }
                                }
                            }, '查看')];
                            return h('div', showElements);
                        }
                    }
                ],
                detailColumns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '单号', key: 'warehouseEntryRecordBillCode', width: 200, align: 'center', excel: true },
                    { title: '批次', key: 'warehouseEntryRecordBatchCode', align: 'center', excel: true },
                    { title: '苗场', key: 'seedFarmName', align: 'center', excel: true },
                    { title: '产品编号', key: 'warehouseEntryDetailProductCode', align: 'center', excel: true },
                    { title: '产品名称', key: 'warehouseEntryDetailProductName', align: 'center', excel: true },
                    { title: '销售周期', key: 'warehouseEntryDetailSalePeriod', align: 'center', excel: true },
                    { title: '单价', key: 'warehouseEntryDetailPrice', align: 'center', excel: true },
                    { title: '入库量', key: 'warehouseEntryDetailAmount', align: 'center', excel: true },
                    { title: '金额', key: 'warehouseEntryDetailMoney', align: 'center', excel: true },
                    { title: '入库日期', key: 'warehouseEntryRecordCreateAt', align: 'center', excel: true, render: (h, params) => dateRender(h, params.row.warehouseEntryRecordCreateAt) }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '单号', type: 'Input', value: '', name: 'warehouseEntryRecordBillCode', sql: 'like' },
                    { label: '苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '批次', type: 'Input', value: '', name: 'warehouseEntryRecordBatchCode', sql: 'like' },
                    { label: '入库日期', type: 'Daterange', value: '', name: 'warehouseEntryRecordCreateAt', sql: 'dateBetween' }
                ],
                detailSearchForm: [
                    { label: '单号', type: 'Input', value: '', name: 'warehouseEntryRecordBillCode', sql: 'like' },
                    { label: '苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '批次', type: 'Input', value: '', name: 'warehouseEntryRecordBatchCode', sql: 'like' },
                    { label: '产品信息', type: 'Input', value: '', name: 'concat(warehouseEntryDetailProductCode,warehouseEntryDetailProductName)', sql: 'like' },
                    { label: '入库日期', type: 'Daterange', value: '', name: 'warehouseEntryRecordCreateAt', sql: 'dateBetween' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }

        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal() {
            this.show = true;
        },
        init() {
            this.getWarehouseEntryTableRecord();
        },
        onTypeChange() {
            this.getWarehouseEntryTableRecord(true);
        },
        onExport() {
            const searchCondition = search.deepClone(this.mainTable.tableSearch);
            searchCondition.limit.enable = false;
            searchCondition.excelExport.enable = true;
            searchCondition.excelExport.columns = this.mainTable.detailColumns
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });

            this.mainTable.loading = true;
            getAgentWarehouseEntryFullList(searchCondition).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.exportFileName;
                    this.$downLoadFile(url);
                    // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                }
            });
        },
        getWarehouseEntryTableRecord(reset = false) {

            if (reset) {
                // search.globalResetSearch(this.mainTable.tableSearch);
                this.mainTable.tableSearch = search.getSearchParams();

            }
            if (this.type === 'summary') {
                this.mainTable.loading = true;
                getAgentWarehouseEntryList(this.mainTable.tableSearch).then(res => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                    }

                    this.mainTable.loading = false;
                });
            }
            else if (this.type === 'detail') {
                this.mainTable.loading = true;
                getAgentWarehouseEntryFullList(this.mainTable.tableSearch).then(res => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                    }

                    this.mainTable.loading = false;
                });
            }
        },
        onCreateWarehouseEntry() {
            this.$refs.preSaleAgentWarehouseEntryEditModal.showModal();
        }
    }
};
</script>

<style lang="less">
</style>
